import {
  SET_TRIGGER_LOADING,
  SET_CURRENT_MODAL,
  SET_CRON_STATUS,
  SET_CRON_RUNS,
  SET_RESET_LOADING,
  SET_CLEAR_CACHE_LOADING,
} from '../actions';

const initialState = {
  triggerLoading: false,
  resetLoading: false,
  clearCacheLoading: false,
  currentModal: null,
  cronStatus: {
    isCronRunning: false,
    startedAt: null,
    lastRan: null,
  },
  cronRuns: [],
  cronRunsTotal: 0,
  cronRunsPage: 1,
  cronRunsPageSize: 10,
  cronRunsLoading: false,
};

const engagementCaseReport = (state = initialState, { type, data }) => {
  switch (type) {
    case SET_TRIGGER_LOADING:
      return { ...state, triggerLoading: data };
    case SET_RESET_LOADING:
      return { ...state, resetLoading: data };
    case SET_CLEAR_CACHE_LOADING:
      return { ...state, clearCacheLoading: data };
    case SET_CURRENT_MODAL:
      return { ...state, currentModal: data };
    case SET_CRON_STATUS:
      return { ...state, cronStatus: data };
    case SET_CRON_RUNS:
      return { ...state, ...data };
    default:
      return state;
  }
};

export default engagementCaseReport;
